<div class="social-review-preview question-content-width" (click)="$event.stopPropagation()">
  @if (question) {
  <!-- <div class="social-review-preview__card"> -->
    <!-- <div class="social-review-preview__icon">
      <i class="bi bi-star-fill"></i>
    </div>
    <p class="social-review-preview__message">
      {{ question.question || 'Share your experience' }}
    </p>
    @if (question.questionSpecificOptions.reviewProvider === questionSubType.GOOGLE) {
    <div class="social-review-preview__provider">
      <span class="social-review-preview__provider-badge">Google Review</span>
    </div>
    } -->
    @if (showRatingStars) {
    <div class="social-review-preview__rating">
      <div class="social-review-preview__rating-stars buttons-row" aria-label="5 star rating">
        @for (i of ratingStars; track i) {
        <button
          type="button"
          class="rating-icon p-0"
          [class.text-primary]="selectedRating !== null && selectedRating >= i"
          (click)="selectRating(i, $event)"
        >
          <span class="rating-icon-inner">
            <i class="fa-star" [class.fa-solid]="selectedRating !== null && selectedRating >= i" [class.fa-regular]="selectedRating === null || selectedRating < i" aria-hidden="true"></i>
          </span>
        </button>
        }
      </div>
      <!-- @if (getRatingCondition(); as ratingCondition) {
      <p class="social-review-preview__rating-condition">
        {{ getRatingConditionLabel(ratingCondition) }}
      </p>
      } -->
    </div>
    }
  <!-- </div> -->
  }
</div>
